/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function () {
  function initStickyATC(sticky) {
    const formId = sticky.getAttribute('data-form-id');
    if (!formId) return;

    // Ensure the bar isn't trapped in any transformed/overflowed container
    if (sticky.parentElement !== document.body) {
      document.body.appendChild(sticky);
    }

    const form = document.getElementById(formId);
    if (!form) return;

    const vendor = sticky.getAttribute('data-sticky-atc-vendor') || '';
    const buyButtons = form.querySelector('.product-form__buy-buttons');
    if (!buyButtons) return;

    const titleEl = sticky.querySelector('[data-sticky-atc-title]');
    const variantEl = sticky.querySelector('[data-sticky-atc-variant]');
    const priceEl = sticky.querySelector('[data-sticky-atc-price]');
    const imgEl = sticky.querySelector('.sticky-atc__media img');
    const stickyAtcButton = sticky.querySelector('.sticky-atc__button[data-action="add-to-cart"]');
    const mainAtcButton = form.querySelector('[data-action="add-to-cart"]');

    if (stickyAtcButton && mainAtcButton) {
      stickyAtcButton.addEventListener('click', (e) => {
        // Use the theme’s existing AJAX add-to-cart behavior (it expects the clicked button to be inside the form)
        e.preventDefault();
        e.stopPropagation();
        if (stickyAtcButton.hasAttribute('disabled')) return;

        stickyAtcButton.setAttribute('disabled', 'disabled');
        stickyAtcButton.setAttribute('aria-busy', 'true');

        const reEnable = () => {
          stickyAtcButton.removeAttribute('disabled');
          stickyAtcButton.removeAttribute('aria-busy');
        };

        const onProductAdded = (event) => {
          // Only re-enable for adds triggered from this form if possible
          const addedFormId = event?.detail?.formId;
          if (addedFormId && addedFormId !== formId) return;
          cleanup();
          reEnable();
        };

        const onLoadingEnd = () => {
          // Also re-enable on error paths where product:added might not fire
          cleanup();
          reEnable();
        };

        const cleanup = () => {
          document.removeEventListener('product:added', onProductAdded);
          document.removeEventListener('theme:loading:end', onLoadingEnd);
        };

        document.addEventListener('product:added', onProductAdded);
        document.addEventListener('theme:loading:end', onLoadingEnd, { once: true });

        mainAtcButton.click();
      });
    }

    const setVisible = (visible) => {
      sticky.classList.toggle('is-visible', visible);
      sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
    };

    const observer = new IntersectionObserver(
      (entries) => {
        const isBuyButtonsVisible = entries[0]?.isIntersecting;
        setVisible(!isBuyButtonsVisible);
      },
      { root: null, threshold: 0.15 }
    );

    observer.observe(buyButtons);

    form.addEventListener('variant:changed', (event) => {
      const v = event?.detail?.variant;
      if (!v) return;

      if (variantEl && !variantEl.textContent.trim()) variantEl.textContent = vendor;

      if (priceEl) {
        const moneyEl =
          form.querySelector('.product-form__info-content .price-list .price--highlight') ||
          form.querySelector('.product-form__info-content .price-list .price');
        if (moneyEl) priceEl.textContent = moneyEl.textContent.trim();
      }

      if (imgEl && v.featured_media && v.featured_media.preview_image && v.featured_media.preview_image.src) {
        imgEl.src = v.featured_media.preview_image.src;
      }

      if (titleEl && !titleEl.textContent.trim()) titleEl.textContent = vendor || document.title || '';
    });
  }

  function boot() {
    document.querySelectorAll('[data-sticky-atc]').forEach(initStickyATC);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();

